import { Button } from "@material-ui/core";
import React from "react";
import Media from "react-media";
import { Route } from "react-router-dom";
import { HeaderDesktop } from "../../../components/header/desktop/HeaderDesktop";
import { HeaderMobile } from "../../../components/header/mobile/HeaderMobile";
import { RadioButton } from "../../../components/radio-button/RadioButton";
import { GoogleTagManagerService } from "../../../services/analitycs/GoogleTagManagerService";
import './ChooseTypeAddProduct.css';

export class ChooseTypeAddProduct extends React.Component<any, any> {
    constructor(props: any){
        super(props);

        this.state = {
            selected: "first"
        }
    }

    private renderDesktopHeader(): JSX.Element {
        return (
            <HeaderDesktop showBack={true} showLogout={false} showTitle={true} title={"Crea Prodotto"}/>);
    }

    private renderMobileHeader(): JSX.Element {
        return (
            <HeaderMobile showBack={true} showLogout={false} showTitle={true} title={"Crea Prodotto"}/>);
    }

    componentDidMount(){
        GoogleTagManagerService.getInstance().pushInteractionEvent('popupImpression', 'Popup', 'impression', 'catalogo prodotti: creazione prodotto: scegli come inserire il prodotto');
    }

    private changeStatus(status: string){
        console.log("[ChooseTypeAddProduct] Change status to: " + status);
        this.setState({selected: status});
    }

    private manageOperation(history: any){
        if(this.state.selected === "first"){
            // Manual insert
            console.log("[ChooseTypeAddProduct] Manual insert choosen");
            history.push('/addProduct/insertOrUpdate');
        } else {
            // Excel insert
            console.log("[ChooseTypeAddProduct] Excel insert choosen");
            history.push('/addProduct/import');
        }
    }

    render(){
        return <div id={"main-container-choose-type-add-product"}>
            <Media query="(max-width: 1064px)" render={() => this.renderMobileHeader() }/>
            <Media query="(min-width: 1065px)" render={() => this.renderDesktopHeader() }/>
            <div className={"choose-type-add-product-container-content"}>
                <div className={"choose-type-add-product-main-radio-container"}>
                    <p className={"choose-type-add-product-main-title"}>Scegli come inserire il prodotto</p>
                    <RadioButton textName={"Inserisci prodotti manualmente"} textDescription={"Inserisci tutte le informazioni e le immagini del prodotto manualmente."} 
                        value="first" selected={this.state.selected} onChange={() => this.changeStatus("first")} titleClass={"choose-type-add-product-title"} subtitleClass={"choose-type-add-product-subtitle"}/>
                    <RadioButton textName={"Importa prodotti da file Excel"} textDescription={"Importa massivamente le informazioni dei tuoi prodotti tramite un file Excel da inserire nel catalogo."} 
                        value="second" selected={this.state.selected} onChange={() => this.changeStatus("second")} titleClass={"choose-type-add-product-title"} subtitleClass={"choose-type-add-product-subtitle"}/>
                </div>
                <div className={"choose-type-add-product-button-go-container"}>
                    <Route render={({history}) => {
                        return <Button id={"choose-type-add-product-button-go"}
                            type={"button"} onClick={() => {
                                this.manageOperation(history);
                            }}>AVANTI</Button>
                    }}/>
                </div>
            </div>
        </div>
    }
}